import React, { useMemo } from "react";
import { useStandardProductContext } from "app/providers/StandardProductProvider";
import Slider from "react-slick";
import { REACT_APP_GERS_API_URL } from "shared/config";
import { twMerge } from "tailwind-merge";
import ArrowNext from "./components/ArrowNext";
import ArrowPrevious from "./components/ArrowPrevious";
import classNames from "classnames";

interface Props {
  className?: string;
}
const StandardProductSceneCarousel = ({ className }: Props) => {
  const { store } = useStandardProductContext();

  const sliderImages = useMemo(() => {
    const images: string[] = [];

    if (store.selectedStandardProduct?.imageId) {
      images.push(store.selectedStandardProduct.imageId);
    }
    if (store.selectedStandardProduct?.images) {
      images.push(...store.selectedStandardProduct.images);
    }

    return images;
  }, [store.selectedStandardProduct]);

  const settings = {
    customPaging: function (i: number) {
      return (
        <button
          className="gg-transition-all gg-duration-300 gg-ease-in-out hover:gg-scale-105"
          aria-label={`Product ${i}`}
        >
          <img
            src={`${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${
              sliderImages[i] || ""
            }`}
            alt=""
            className="gg-aspect-square gg-h-12 gg-cursor-pointer gg-border gg-object-cover gg-object-center sm:gg-h-20 md:gg-h-24 lg:gg-h-20 xl:gg-h-24 2xl:gg-h-[7.5rem]"
            role="presentation"
          />
        </button>
      );
    },
    dots: true,
    dotsClass:
      "2xl:gg-h-[7.5rem] lg:gg-h-28 xl:gg-h-24 md:gg-h-28 gg-h-15 sm:gg-h-24 sm:gg-py-4 gg-justify-center gg-pt-2 gg-gap-4 gg-flex slick-thumb",
    infinite: true,

    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <ArrowNext />,
    prevArrow: <ArrowPrevious />,
  };

  return (
    <div className={twMerge("gg-container gg-mx-auto gg-px-1", className)}>
      <Slider {...settings}>
        {sliderImages.map(
          (image: string) =>
            image.length !== 0 && (
              <div
                className={classNames(
                  "gg-col-span-full gg-h-96 sm:gg-h-[33rem] md:gg-h-[39.5rem] md:gg-px-2 lg:gg-h-[30rem] xl:gg-h-[30rem] 2xl:gg-h-[39.5rem]",
                  {
                    "xl:gg-h-[38.345rem] 2xl:gg-h-[36.66rem]":
                      store?.selectedStandardProductCategory?.code ===
                      "glasreiniger",
                    "xl:gg-h-[44.97rem]":
                      store?.selectedStandardProductCategory?.code ===
                      "verfset",
                  },
                )}
                key={image}
              >
                <div className="gg-relative gg-h-full gg-w-full">
                  <img
                    alt=""
                    src={`${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${image}`}
                    className="gg-h-full gg-w-full gg-object-cover gg-object-center"
                  />
                </div>
              </div>
            ),
        )}
      </Slider>
    </div>
  );
};

export default StandardProductSceneCarousel;
